import { render, staticRenderFns } from "./TableLiveEvents.vue?vue&type=template&id=46edb81e&scoped=true"
import script from "./TableLiveEvents.js?vue&type=script&lang=js&external"
export * from "./TableLiveEvents.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46edb81e",
  null
  
)

export default component.exports